import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4c634962&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4c634962&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=4c634962&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c634962",
  null
  
)

export default component.exports